import { render, staticRenderFns } from "./CommentHistory.vue?vue&type=template&id=5133ad92&scoped=true"
import script from "./CommentHistory.vue?vue&type=script&lang=js"
export * from "./CommentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133ad92",
  null
  
)

export default component.exports